"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlBlockTemplateValidationError = void 0;
exports.validateHtmlBlockTemplate = validateHtmlBlockTemplate;
exports.renderHtmlBlock = renderHtmlBlock;
const isomorphic_dompurify_1 = __importDefault(require("isomorphic-dompurify"));
const mustache_1 = __importDefault(require("mustache"));
class HtmlBlockTemplateValidationError extends Error {
    constructor(reason, hint) {
        super(`${reason}. ${hint}`);
        this.reason = reason;
        this.hint = hint;
        this.name = 'HtmlBlockTemplateValidationError';
    }
}
exports.HtmlBlockTemplateValidationError = HtmlBlockTemplateValidationError;
const RAW_MUSTACHE_PATTERNS = [/{{{\s*[^}]+}}}/, /{{&\s*[^}]+}}/];
function validateHtmlBlockTemplate(template) {
    for (const pattern of RAW_MUSTACHE_PATTERNS) {
        if (pattern.test(template)) {
            throw new HtmlBlockTemplateValidationError('Raw Mustache output is disabled', 'Use escaped {{value}} placeholders; rendered HTML is sanitized after interpolation.');
        }
    }
}
function renderHtmlBlock(template, data) {
    validateHtmlBlockTemplate(template);
    const rendered = mustache_1.default.render(template, data);
    return isomorphic_dompurify_1.default.sanitize(rendered, {
        ALLOW_DATA_ATTR: true,
        FORBID_ATTR: ['style'],
        FORBID_TAGS: [
            'base',
            'embed',
            'form',
            'iframe',
            'input',
            'link',
            'meta',
            'object',
            'script',
            'select',
            'style',
            'textarea',
        ],
    });
}
